/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TerraformImport } from './routes/terraform'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const TerraformRoute = TerraformImport.update({
  id: '/terraform',
  path: '/terraform',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/terraform': {
      id: '/terraform'
      path: '/terraform'
      fullPath: '/terraform'
      preLoaderRoute: typeof TerraformImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/terraform': typeof TerraformRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/terraform': typeof TerraformRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/terraform': typeof TerraformRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/terraform'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/terraform'
  id: '__root__' | '/' | '/terraform'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TerraformRoute: typeof TerraformRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TerraformRoute: TerraformRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/terraform"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/terraform": {
      "filePath": "terraform.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
